import styles from './List.module.scss';
import { Spinner } from '../spinners/Spinner';
import { useContext } from 'react';
import { ContainerContext } from '../containers/ContainerContext';

interface Props {
  children?: React.ReactNode;
  loading?: boolean | string;
  ordered?: boolean;
  spacing?: 'none' | 'top' | 'bottom';
}

export function List({ spacing = 'none', ordered = false, ...props }: Props) {
  const containerContext = useContext(ContainerContext);

  const className = [
    styles['list'],
    styles[`list-spacing-${spacing}`],
    ordered && styles['list-ordered'],
    containerContext && styles['list-contained'],
  ]
    .filter(Boolean)
    .join(' ');

  return props.loading ? (
    <Spinner
      message={typeof props.loading == 'string' ? props.loading : undefined}
    />
  ) : ordered ? (
    <ol className={className}>{props.children}</ol>
  ) : (
    <ul className={className}>{props.children}</ul>
  );
}
